import { getConstanceSettings } from '@disco/state-management/selectors/user'

import { useSelector } from 'hooks/use-redux'

import type { State } from 'types/redux'

/**
 * Hook to check if the new rights holder API model is enabled.
 *
 * This feature flag controls whether to use the new RTK Query API
 * (RightsHolders endpoints) or the old Redux thunk API for
 * creating and updating PROs, Publishers, and Writers.
 *
 * When the migration is complete (SLAM-1413), this hook can be
 * removed and all code can use the new API directly.
 */
export function useRightsNewModelEnabled(): boolean {
  const constanceSettings = useSelector((state: State) =>
    getConstanceSettings(state),
  )
  return constanceSettings?.TRACK_RIGHTS_HOLDERS_WRITE_TO_NEW_MODELS || false
}
